import { WifiStrengthOutlineIcon } from './WifiStrengthOutlineIcon';

/**
 * author: Simran
 * id 0DAAFF13-5A8D-44C3-AE46-9DDE62493C60
 * name wifi-strength-outline
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/wifi-strength-outline.svg
 * tags
 */
export const WifiStrength0Icon = WifiStrengthOutlineIcon;
export default WifiStrength0Icon